import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Navbar from './Navbar';
import Footer from './Footer';
import HoroscopeSection from '../Horoscope/HoroscopeSection';
import './LandingPage.css';

const LandingPage = () => {
    // Effet pour scroll vers le haut à l'arrivée sur la page
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <Helmet>
                <title>AstraLight | Votre guide personnel d'astrologie en ligne</title>
                <meta name="description" content="Découvrez votre thème astral, votre compatibilité amoureuse et explorez les secrets des astres. Analyses astrologiques précises et gratuites." />
                <meta name="keywords" content="astrologie, thème astral, compatibilité amoureuse, horoscope, zodiaque, planètes, signes astrologiques" />
                <link rel="canonical" href="https://astralight.xyz/" />
                
                {/* Schema.org pour Website */}
                <script type="application/ld+json">
                {`
                    {
                        "@context": "https://schema.org",
                        "@type": "WebSite",
                        "name": "AstraLight",
                        "url": "https://astralight.xyz/",
                        "description": "Plateforme d'astrologie proposant des outils d'analyse de thème astral et de compatibilité amoureuse",
                        "potentialAction": {
                            "@type": "SearchAction",
                            "target": "https://astralight.xyz/search?q={search_term_string}",
                            "query-input": "required name=search_term_string"
                        }
                    }
                `}
                </script>
            </Helmet>

            <Navbar />

            <main className="landing-page">
                <section className="hero">
                    <div className="container">
                        <div className="hero-content panel">
                            <h1>Explorez le langage des étoiles</h1>
                            <p className="hero-subtitle">Découvrez votre carte céleste et les influences cosmiques qui façonnent votre vie</p>
                            <div className="hero-buttons">
                                <Link to="/calcul-theme-astral" className="hero-button">
                                    Découvrir mon thème astral
                                </Link>
                                <Link to="/compatibilite-amoureuse-astrologie" className="hero-button secondary">
                                    Tester ma compatibilité
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="features">
                    <div className="container">
                        <h2>Nos outils astrologiques</h2>
                        <div className="features-grid">
                            <div className="feature-card panel">
                                <div className="feature-icon theme-natal-icon"></div>
                                <h3>Thème Astral</h3>
                                <p>Obtenez une analyse détaillée de votre carte du ciel à votre naissance. Découvrez vos forces, défis et potentiels cachés.</p>
                                <Link to="/calcul-theme-astral" className="feature-link">Calculer mon thème</Link>
                            </div>
                            
                            <div className="feature-card panel">
                                <div className="feature-icon compatibility-icon"></div>
                                <h3>Compatibilité Amoureuse</h3>
                                <p>Explorez votre alchimie avec votre partenaire ou votre crush. Analysez vos synergies et points de tension.</p>
                                <Link to="/compatibilite-amoureuse-astrologie" className="feature-link">Vérifier ma compatibilité</Link>
                            </div>
                            
                            <div className="feature-card panel">
                                <div className="feature-icon blog-icon"></div>
                                <h3>Blog Astrologique</h3>
                                <p>Enrichissez vos connaissances avec nos articles sur les planètes, signes et phénomènes astrologiques.</p>
                                <Link to="/blog" className="feature-link">Explorer les articles</Link>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="about">
                    <div className="container">
                        <div className="about-content panel">
                            <h2>Pourquoi AstraLight?</h2>
                            <div className="about-grid">
                                <div className="about-item">
                                    <h3>Précision</h3>
                                    <p>Nos calculs astronomiques utilisent les données les plus récentes pour une analyse rigoureuse de votre position céleste.</p>
                                </div>
                                <div className="about-item">
                                    <h3>Simplicité</h3>
                                    <p>Une interface intuitive qui rend l'astrologie accessible à tous, des débutants aux connaisseurs.</p>
                                </div>
                                <div className="about-item">
                                    <h3>Profondeur</h3>
                                    <p>Au-delà des horoscopes généralistes, plongez dans les subtilités de votre carte du ciel personnelle.</p>
                                </div>
                                <div className="about-item">
                                    <h3>Gratuité</h3>
                                    <p>Accédez à des outils astrologiques professionnels sans frais cachés ni abonnement obligatoire.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="blog-preview">
                    <div className="container">
                        <h2>Explorez notre blog d'astrologie</h2>
                        <div className="blog-grid">
                            <article className="blog-card panel">
                                <img src="/images/planetes/lune.webp" alt="La Lune en astrologie" className="blog-image" />
                                <div className="blog-content">
                                    <h3>La Lune en Astrologie</h3>
                                    <p>Découvrez l'influence de la Lune sur vos émotions et votre monde intérieur.</p>
                                    <Link to="/blog/planetes/lune" className="blog-link">Lire l'article</Link>
                                </div>
                            </article>
                            
                            <article className="blog-card panel">
                                <img src="/images/signes/belier.webp" alt="Le Bélier" className="blog-image" />
                                <div className="blog-content">
                                    <h3>Le Bélier</h3>
                                    <p>Tempérament, forces et défis du premier signe du zodiaque.</p>
                                    <Link to="/blog/signes/belier" className="blog-link">Lire l'article</Link>
                                </div>
                            </article>
                            
                            <article className="blog-card panel">
                                <img src="/images/planetes/venus.webp" alt="Vénus en astrologie" className="blog-image" />
                                <div className="blog-content">
                                    <h3>Vénus en Astrologie</h3>
                                    <p>Comment la planète de l'amour influence vos relations et vos attirances.</p>
                                    <Link to="/blog/planetes/venus" className="blog-link">Lire l'article</Link>
                                </div>
                            </article>
                        </div>
                        <div className="blog-more">
                            <Link to="/blog" className="blog-more-link">Voir tous les articles</Link>
                        </div>
                    </div>
                </section>

                <HoroscopeSection />

                <section className="cta">
                    <div className="container">
                        <div className="cta-content panel">
                            <h2>Prêt à découvrir ce que les étoiles vous réservent?</h2>
                            <p>Commencez votre voyage astrologique dès maintenant, gratuitement et sans inscription.</p>
                            <div className="cta-buttons">
                                <Link to="/calcul-theme-astral" className="cta-button">
                                    Calculer mon thème astral
                                </Link>
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </>
    );
};

export default LandingPage; 